var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect, _path26, _path27, _path28, _ellipse, _ellipse2, _rect2, _ellipse3, _ellipse4, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 177,
    viewBox: "0 0 141 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_45215)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1681 153.463C109.739 153.463 139.385 123.956 139.385 87.5586C139.385 51.1606 109.739 21.6543 73.1681 21.6543C36.5981 21.6543 6.95215 51.1606 6.95215 87.5586C6.95215 123.956 36.5981 153.463 73.1681 153.463Z",
    fill: "#DFC2EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1681 153.463C109.739 153.463 139.385 123.956 139.385 87.5586C139.385 51.1606 109.739 21.6543 73.1681 21.6543C36.5981 21.6543 6.95215 51.1606 6.95215 87.5586C6.95215 123.956 36.5981 153.463 73.1681 153.463Z",
    fill: "#DFC2EE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_946_45215)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_946_45215)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1105 120.698L91.2711 85.4604C91.3152 75.683 83.3255 67.3471 73.5118 67.4951C64.0071 67.6396 56.3347 75.3386 56.2905 84.8476L56.1258 120.782C56.0735 132.537 51.2892 162.093 43.1346 170.582C35.1004 178.946 30.1152 172.195 30.1152 185.091C30.1152 210.544 49.5217 231.18 73.4594 231.18C97.3972 231.18 116.804 210.544 116.804 185.091C116.804 172.327 111.923 179.186 104.033 170.846C95.8709 162.21 91.0503 132.561 91.1066 120.698H91.1105Z",
    fill: "#FFE8BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7001 131.028L67.6748 146.503C67.5259 146.959 67.5338 147.456 67.6948 147.908L72.8005 162.226C73.5115 164.219 76.3715 164.14 76.9699 162.11L81.5898 146.391C81.7142 145.962 81.7063 145.51 81.5658 145.085L76.8617 131.016C76.1948 129.014 73.3469 129.026 72.6957 131.032L72.7001 131.028Z",
    fill: "#FFFFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6527 14.0684C103.349 13.7361 112.624 30.3599 105.112 48.2249C98.5043 63.9521 88.9354 65.1013 85.9628 65.7298L84.6211 61.4455C84.6211 61.4455 88.53 56.7052 91.4743 46.4472C95.2383 33.3348 93.1978 14.3286 97.6527 14.0684Z",
    fill: "#FFE8BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7463 30.3841C101.855 27.6134 107.772 35.4409 100.534 51.096C95.6008 61.7699 87.667 63.7401 87.667 63.7401C87.667 63.7401 91.7443 58.0906 94.8576 49.9948C99.8065 37.1305 97.9066 32.8024 99.7463 30.3881V30.3841Z",
    fill: "#FE8C79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2429 14.0684C42.5467 13.7361 33.2713 30.3599 40.7832 48.2249C47.3913 63.9521 56.9599 65.1013 59.9326 65.7298L61.2742 61.4455C61.2742 61.4455 57.3657 56.7052 54.4212 46.4472C50.6571 33.3348 52.6978 14.3286 48.2429 14.0684Z",
    fill: "#FFE8BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.15 30.3841C44.041 27.6134 38.1239 35.4409 45.3626 51.096C50.2956 61.7699 58.2293 63.7401 58.2293 63.7401C58.2293 63.7401 54.152 58.0906 51.0387 49.9948C46.0897 37.1305 47.9898 32.8024 46.15 30.3881V30.3841Z",
    fill: "#FE8C79"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3289 94.0532C86.8116 80.8609 81.5222 69.9596 74.5141 69.7047C67.5055 69.4499 61.4327 79.9378 60.9495 93.1301C60.4668 106.322 65.7566 117.224 72.7648 117.479C79.7729 117.733 85.8457 107.245 86.3289 94.0532Z",
    fill: "#FFE8BC"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6241 71.0386C95.6241 60.3525 85.477 51.6841 72.9639 51.6841C60.4507 51.6841 50.3037 60.3486 50.3037 71.0386C50.3037 75.655 52.1998 79.8912 55.3612 83.2183C56.2972 84.2034 56.7953 85.6206 56.7913 87.1259C56.7913 87.142 56.7913 87.1543 56.7913 87.17C56.7913 94.8014 64.034 100.987 72.9682 100.987C81.902 100.987 89.145 94.8014 89.145 87.17C89.145 87.1543 89.145 87.142 89.145 87.1259C89.1367 85.6206 89.639 84.2034 90.5748 83.2183C93.7365 79.8912 95.6324 75.655 95.6324 71.0386H95.6241Z",
    fill: "#FFE8BC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6905 87.8787C71.5572 87.8787 65.8488 86.2172 65.5917 86.9338C63.9406 91.5262 74.6665 93.2519 74.6665 93.2519C78.7997 92.2629 82.568 89.3919 81.8928 87.3541C81.672 86.6855 79.0249 87.8827 74.6905 87.8787Z",
    fill: "#D65832"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8486 75.511C82.1897 75.6363 82.5777 75.6293 82.9332 75.4646C84.6504 74.6696 86.1627 74.5123 87.4666 75.0279C89.5534 75.8475 90.5018 78.1352 90.5127 78.1606C90.807 78.8838 91.6332 79.2346 92.3587 78.9482C93.0846 78.6617 93.4437 77.8417 93.1564 77.1186C93.1026 76.9789 91.7733 73.6959 88.5442 72.4072C86.4968 71.6087 84.2051 71.7554 81.737 72.9013C81.026 73.2307 80.7172 74.0717 81.0474 74.7843C81.2129 75.1387 81.5072 75.3928 81.8486 75.5181V75.511Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1109 75.511C63.7698 75.6363 63.3818 75.6293 63.0263 75.4646C61.3091 74.6696 59.7969 74.5123 58.493 75.0279C56.406 75.8475 55.4577 78.1352 55.4469 78.1606C55.1524 78.8838 54.3262 79.2346 53.6006 78.9482C52.8751 78.6617 52.5158 77.8417 52.8032 77.1186C52.8571 76.9789 54.1861 73.6959 57.4154 72.4072C59.4628 71.6087 61.7544 71.7554 64.2221 72.9013C64.9336 73.2307 65.2423 74.0717 64.9121 74.7843C64.7466 75.1387 64.452 75.3928 64.1109 75.5181V75.511Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_946_45215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 21,
    width: 133,
    height: 133
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.615 153.642C110.261 153.642 139.968 124.136 139.968 87.7377C139.968 51.3398 110.261 21.8335 73.615 21.8335C36.9697 21.8335 7.2627 51.3398 7.2627 87.7377C7.2627 124.136 36.9697 153.642 73.615 153.642Z",
    fill: "#DFC2EE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_946_45215)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9961 119.936L91.1578 84.6982C91.2022 74.9208 83.1581 66.5849 73.2777 66.7329C63.7084 66.8774 55.9837 74.5764 55.9392 84.0854L55.7734 120.02C55.7208 131.775 50.904 161.331 42.6938 169.819C34.605 178.184 29.5859 171.433 29.5859 184.329C29.5859 209.782 49.1244 230.417 73.225 230.417C97.3256 230.417 116.864 209.782 116.864 184.329C116.864 171.565 111.95 178.424 104.007 170.084C95.7889 161.447 90.9355 131.799 90.9922 119.936H90.9961Z",
    fill: "#FFE8BC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4616 130.266L67.402 145.741C67.2522 146.197 67.2601 146.693 67.4223 147.146L72.5626 161.463C73.2784 163.457 76.158 163.377 76.7604 161.347L81.4117 145.629C81.537 145.2 81.5291 144.747 81.3876 144.323L76.6515 130.254C75.98 128.252 73.1128 128.264 72.4572 130.27L72.4616 130.266Z",
    fill: "#FFFFF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5832 13.3062C103.318 12.9739 112.657 29.5977 105.093 47.4627C98.4405 63.1899 88.8066 64.3391 85.8137 64.9675L84.4629 60.6833C84.4629 60.6833 88.3984 55.943 91.3627 45.685C95.1523 32.5725 93.098 13.5664 97.5832 13.3062Z",
    fill: "#FFE8BC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6908 29.6219C101.814 26.8512 107.771 34.6787 100.483 50.3338C95.5171 61.0077 87.5293 62.9779 87.5293 62.9779C87.5293 62.9779 91.6344 57.3284 94.7688 49.2326C99.7514 36.3683 97.8386 32.0402 99.6908 29.6259V29.6219Z",
    fill: "#FE8C79"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8372 13.3062C42.1023 12.9739 32.7637 29.5977 40.3268 47.4627C46.9798 63.1899 56.6135 64.3391 59.6064 64.9675L60.9571 60.6833C60.9571 60.6833 57.022 55.943 54.0575 45.685C50.2679 32.5725 52.3224 13.5664 47.8372 13.3062Z",
    fill: "#FFE8BC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7299 29.6219C43.6066 26.8512 37.6492 34.6787 44.9372 50.3338C49.9037 61.0077 57.8914 62.9779 57.8914 62.9779C57.8914 62.9779 53.7863 57.3284 50.6519 49.2326C45.6692 36.3683 47.5822 32.0402 45.7299 29.6259V29.6219Z",
    fill: "#FE8C79"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1824 93.291C86.6684 80.0987 81.343 69.1974 74.2872 68.9425C67.231 68.6876 61.1168 79.1756 60.6304 92.3679C60.1444 105.56 65.4702 116.461 72.526 116.716C79.5818 116.971 85.696 106.483 86.1824 93.291Z",
    fill: "#FFE8BC"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5408 70.2764C95.5408 59.5903 85.3247 50.9219 72.7264 50.9219C60.1282 50.9219 49.9121 59.5864 49.9121 70.2764C49.9121 74.8928 51.8211 79.129 55.004 82.4561C55.9464 83.4412 56.4479 84.8583 56.4438 86.3637C56.4438 86.3798 56.4438 86.392 56.4438 86.4078C56.4438 94.0392 63.7358 100.225 72.7308 100.225C81.7254 100.225 89.0176 94.0392 89.0176 86.4078C89.0176 86.392 89.0176 86.3798 89.0176 86.3637C89.0092 84.8583 89.515 83.4412 90.4571 82.4561C93.6403 79.129 95.5492 74.8928 95.5492 70.2764H95.5408Z",
    fill: "#FFE8BC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4655 87.1165C71.3109 87.1165 65.5636 85.455 65.3048 86.1716C63.6425 90.764 74.4413 92.4897 74.4413 92.4897C78.6026 91.5007 82.3966 88.6297 81.7168 86.5919C81.4945 85.9233 78.8294 87.1205 74.4655 87.1165Z",
    fill: "#D65832"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7878 74.7495C84.1402 74.8781 84.541 74.8709 84.9084 74.7019C86.6825 73.886 88.245 73.7246 89.5922 74.2537C91.7482 75.0947 92.728 77.4424 92.7393 77.4685C93.0433 78.2106 93.8969 78.5706 94.6465 78.2767C95.3965 77.9827 95.7675 77.1413 95.4707 76.3991C95.4151 76.2558 94.0417 72.8868 90.7055 71.5644C88.5902 70.745 86.2225 70.8955 83.6725 72.0714C82.9378 72.4094 82.6189 73.2725 82.96 74.0038C83.131 74.3674 83.435 74.6282 83.7878 74.7567V74.7495Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6387 74.7495C62.2863 74.8781 61.8855 74.8709 61.5181 74.7019C59.744 73.886 58.1816 73.7246 56.8344 74.2537C54.6782 75.0947 53.6985 77.4424 53.6873 77.4685C53.383 78.2106 52.5294 78.5706 51.7798 78.2767C51.0301 77.9827 50.659 77.1413 50.9559 76.3991C51.0116 76.2558 52.3847 72.8868 55.7211 71.5644C57.8365 70.745 60.204 70.8955 62.7536 72.0714C63.4887 72.4094 63.8076 73.2725 63.4665 74.0038C63.2955 74.3674 62.9911 74.6282 62.6387 74.7567V74.7495Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.999 54.7946C58.6069 44.848 78.108 30.9228 95.249 54.7946",
    stroke: "#6B4F7A",
    strokeWidth: 0.941489
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0566 63.2681C43.3093 75.5074 34.2396 99.892 59.4715 99.5154",
    stroke: "black",
    strokeWidth: 0.941489
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.5303,
    y: 98.103,
    width: 6.59043,
    height: 2.82447,
    rx: 0.941489,
    fill: "#515151"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6938 55.471C51.7932 52.4977 55.9055 51.7893 58.8788 53.8887L55.741 57.3726C54.4673 58.7867 53.3774 60.3561 52.4972 62.0435L50.7331 65.4251C47.7598 63.3257 47.0513 59.2134 49.1507 56.2401L49.6938 55.471Z",
    fill: "#614570"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9009 55.471C94.8015 52.4977 90.6893 51.7893 87.716 53.8887L90.8537 57.3726C92.1274 58.7867 93.2173 60.3561 94.0976 62.0435L95.8617 65.4251C98.835 63.3257 99.5434 59.2134 97.444 56.2401L96.9009 55.471Z",
    fill: "#6B4F7A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3281 71.9081C72.0301 71.1259 74.1078 70.0309 76.8032 71.9081",
    stroke: "#A9BEE7",
    strokeWidth: 2.34648
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.2037,
    cy: 73.0811,
    rx: 10.5592,
    ry: 10.5592,
    fill: "#E1E3E8",
    fillOpacity: 0.62
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.2037,
    cy: 73.0811,
    rx: 10.5592,
    ry: 10.5592,
    stroke: "#CDDAED",
    strokeWidth: 1.56432
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4713,
    y: 61.3487,
    width: 23.4648,
    height: 23.4648,
    rx: 11.7324,
    stroke: "#B2C5EB",
    strokeWidth: 2.34648
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.9264,
    cy: 73.0811,
    rx: 10.5592,
    ry: 10.5592,
    fill: "#E1E3E8",
    fillOpacity: 0.62
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.9264,
    cy: 73.0811,
    rx: 10.5592,
    ry: 10.5592,
    stroke: "#CDDAED",
    strokeWidth: 1.56432
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.1939,
    y: 61.3487,
    width: 23.4648,
    height: 23.4648,
    rx: 11.7324,
    stroke: "#B2C5EB",
    strokeWidth: 2.34648
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_45215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 177,
    fill: "white",
    transform: "translate(0.330078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_946_45215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.224,
    height: 144.586,
    fill: "white",
    transform: "translate(16.9951)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_946_45215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.224,
    height: 177.2,
    fill: "white",
    transform: "translate(16.5498 0.264648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.faf87161a55e48e7d54eff57cdbee078.svg";
export { ForwardRef as ReactComponent };